import { p as palette } from '../base/color-ec580bc4.js';
import { s as spacing, m as mobileSpacing } from '../base/spacing-b4d393ed.js';
import { t as typography, d as fontSizes, m as mobileFontSizes } from '../base/typography-dd13a6be.js';

/* eslint-disable id-length */
const pill = {
  bg: palette.gray[200],
  color: typography.color.primary,
  closeButton: {
    color: palette.gray[700],
    disabledColor: palette.gray[300],
    hoverColor: palette.squidInk
  },
  disabledBg: palette.gray[100],
  disabledText: typography.color.tertiary,
  paddingInlineStart: spacing.small,
  paddingInlineEnd: '3px',
  radius: '30px',
  maxWidth: '500px',
  lineHeight: '22px',
  fontSize: fontSizes.small,
  iconPadding: `0 ${spacing.micro} 2px ${spacing.micro}`
};
const mobilePill = {
  mobile: {
    fontSize: mobileFontSizes.small,
    iconPadding: `0 ${mobileSpacing.micro} 2px ${mobileSpacing.micro}`
  }
};
var pillLegacyStyles = pill;

export { mobilePill as m, pillLegacyStyles as p };
//# sourceMappingURL=pillLegacy-189bffbc.js.map
